import React, { useCallback, useEffect, useState, useRef } from 'react';
import Dialog from '../../common/components/Dialog';
import { PremiumNewsletterModalProps } from '../types/NewsletterPage';
import CloseButton from '../../settings/components/modals/CloseModalButton';
import useClickOutside from '../../settings/hooks/useModalClickHandler';

const PremiumNewsletterModal: React.FC<PremiumNewsletterModalProps> = ({
  isOpen,
  onClose,
  modalContent,
  shouldOpenPremodal,
}) => {
  const [isDialogOpen, setIsDialogOpen] = useState<boolean>(isOpen);
  const modalRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    setIsDialogOpen(isOpen);
  }, [isOpen]);

  const closeDialog = useCallback(() => {
    setIsDialogOpen(false);
    onClose(); // Call the onClose prop to notify the parent component
  }, [onClose]);

  useClickOutside(modalRef, closeDialog);

  if (!modalContent) return null;

  return (
    <Dialog isOpen={isDialogOpen} onClose={closeDialog}>
      <div
        ref={modalRef}
        className={
          modalContent.header_background_image
            ? 'premium-newsletter-modal--bg-image modal modal--large premium-newsletter-modal'
            : 'modal modal--large premium-newsletter-modal'
        }
      >
        <div className="modal__wrapper">
          <div
            className="premium-newsletter-modal__header modal__header"
            style={{
              backgroundImage: modalContent.header_background_image
                ? `url(${modalContent.header_background_image})`
                : '',
            }}
          >
            <h5 className="premium-newsletter-modal__title archivo">{modalContent.title}</h5>

            <CloseButton onClose={closeDialog} />
          </div>

          <div className="premium-newsletter-modal__content modal__content">
            <div dangerouslySetInnerHTML={{ __html: modalContent.content }} />
          </div>

          <div className="premium-newsletter-modal__footer modal__footer">
            <a className="premium-newsletter-modal__button link link-16" href={modalContent.button_link}>
              {modalContent.button_label}
            </a>
          </div>
        </div>
      </div>
    </Dialog>
  );
};

export default PremiumNewsletterModal;
